import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

// Every route carries its own `meta.sysadmin` because route guards evaluate each
// matched record's own meta (see routesWithAuthorization in permissions.helpers).
export const SysadminRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/sysadmin/tenants'
    },
    {
        path: 'tenants',
        component: wrapRuntimeImport(() => import('./screens/tenants.vue')),
        meta: { sysadmin: true }
    },
    {
        path: 'tenants/:id',
        component: wrapRuntimeImport(() => import('./screens/tenants/detail.vue')),
        meta: { sysadmin: true, subAppName: 'Tenant' }
    },
    {
        path: 'permission-sets',
        component: wrapRuntimeImport(() => import('./screens/permission-sets.vue')),
        meta: { sysadmin: true, subAppName: 'Permission Sets' }
    },
    {
        path: 'talk-catalog',
        component: wrapRuntimeImport(() => import('./screens/talk-catalog.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Catalog' }
    },
    {
        // Tabs inside the editor are local state rather than child routes — the sysadmin shell keys
        // its <router-view> on the full path, so a route per tab would remount and refetch the draft.
        path: 'talk-catalog/:revision',
        component: wrapRuntimeImport(() => import('./screens/talk-catalog/revision.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Catalog' }
    },
    {
        path: 'talk-service-orders',
        component: wrapRuntimeImport(() => import('./screens/talk-service-orders.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Service Orders' }
    },
    {
        path: 'talk-hardware-orders',
        component: wrapRuntimeImport(() => import('./screens/talk-hardware-orders.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Hardware Orders' }
    },
    {
        path: 'talk-sms-registrations',
        component: wrapRuntimeImport(() => import('./screens/talk-sms-registrations.vue')),
        meta: { sysadmin: true, subAppName: 'Talk SMS Registrations' }
    },
    {
        path: 'talk-outbound-routes',
        component: wrapRuntimeImport(() => import('./screens/talk-outbound-routes.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Outbound Routes' }
    },
    {
        path: 'talk-byoc-numbers',
        component: wrapRuntimeImport(() => import('./screens/talk-byoc-numbers.vue')),
        meta: { sysadmin: true, subAppName: 'Talk BYOC Numbers' }
    },
    {
        path: 'talk-live-calls',
        component: wrapRuntimeImport(() => import('./screens/talk-live-calls.vue')),
        meta: { sysadmin: true, subAppName: 'Talk Live Calls' }
    },
    {
        path: 'talk-sip-registrations',
        component: wrapRuntimeImport(() => import('./screens/talk-sip-registrations.vue')),
        meta: { sysadmin: true, subAppName: 'Talk SIP Registrations' }
    },
    {
        path: 'hosting/clusters',
        component: wrapRuntimeImport(() => import('./screens/hosting/clusters.vue')),
        meta: { sysadmin: true, subAppName: 'Hosting Clusters' }
    },
    {
        path: 'hosting/database-servers',
        component: wrapRuntimeImport(() => import('./screens/hosting/database-servers.vue')),
        meta: { sysadmin: true, subAppName: 'Hosting DB Servers' }
    },
    {
        path: 'hosting/certificates',
        component: wrapRuntimeImport(() => import('./screens/hosting/certificates.vue')),
        meta: { sysadmin: true, subAppName: 'Hosting Certificates' }
    }
];
